module.exports = __webpack_public_path__ + "static/_climate-35325ef8f4c307a5195d856815715b32.jpg";